var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('router-link',{staticClass:"mr-3 btn btn-warning",attrs:{"to":{
      name: 'groupsupplyDetails',
      query: {
        supplyId: _vm.data.id,
        groupId: _vm.$route.query.groupId,
        ..._vm.$route.query,
      },
    }}},[_vm._v("\n  "+_vm._s(_vm.$t('text.clickButtons.details'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }